<template>
  <div>
    <div class="vx-row mt-0">
      <div class="vx-col md:w-1/4 w-full">
        <label class="vs-input--label"><b>Template</b></label>
        <vs-button
          color="success"
          type="filled"
          icon="icon-download"
          icon-pack="feather"
          @click="downloadTemplate"
          :disabled="isLoadingTemplate"
          class="btn-download-success mt-2"
        >
          Download
        </vs-button>
      </div>
    </div>

    <div class="vx-row mt-4">
      <div class="vx-col md:w-1/3 w-full">
        <label class="vs-input--label"><b>File Excel</b></label>
        <div class="vs-con-input mt-2">
          <input
            type="file"
            ref="fileInput"
            accept=".xlsx,.xls"
            v-on:change="handleFileChange"
            class="vs-input--input vs-input--input-normal"
            style="padding:6px 10px;height:38px;cursor:pointer;"
          />
        </div>
      </div>
    </div>

    <div class="vx-row mt-5">
      <div class="vx-col md:w-1/4 w-full">
        <vs-button
          color="primary"
          @click="submitUpdate"
          :disabled="!selectedFile || isSubmitting"
        >
          Process
        </vs-button>
      </div>
    </div>

    <!-- Result Section -->
    <div class="vx-row mt-10" v-if="result">
      <div class="vx-col md:w-full w-full">
        <div style="font-size:14px;font-weight:700;margin-bottom:12px;">Hasil Update</div>
        <div style="border:1px solid #ddd;border-radius:4px;overflow:hidden;">
          <div class="vx-row" style="border-bottom:1px solid #ddd;">
            <div class="vx-col md:w-1/2" style="border-right:1px solid #ddd;padding:12px 16px;background:#e8e8e8;">
              <span style="font-size:14px;font-weight:600;">REFERENCE</span>
            </div>
            <div class="vx-col md:w-1/2" style="padding:12px 16px;background:#e8e8e8;">
              <span style="font-size:14px;font-weight:600;">NEW INBOUND NOTES</span>
            </div>
          </div>
          <div
            v-for="(detail, index) in result.details"
            :key="index"
            class="vx-row"
            :style="index % 2 !== 0 ? 'background:#f8f8f8;border-bottom:1px solid #ddd;' : 'background:#fff;border-bottom:1px solid #ddd;'"
          >
            <div class="vx-col md:w-1/2" style="border-right:1px solid #ddd;padding:12px 16px;">
              <span style="font-size:14px;">{{ detail.reference }}</span>
            </div>
            <div class="vx-col md:w-1/2" style="padding:12px 16px;">
              <span style="font-size:14px;">{{ detail.note }}</span>
            </div>
          </div>
          <div class="vx-row" style="border-top:2px solid #ddd;background:#f0f0f0;">
            <div class="vx-col md:w-1/2" style="padding:12px 16px;">
              <span style="font-size:13px;color:#666;">Rows Processed: </span>
              <span style="font-size:14px;font-weight:600;">{{ result.rows_processed }}</span>
            </div>
            <div class="vx-col md:w-1/2" style="padding:12px 16px;">
              <span style="font-size:13px;color:#666;">Inbounds Updated: </span>
              <span style="font-size:14px;font-weight:600;">{{ result.inbounds_updated }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedFile: null,
      isSubmitting: false,
      isLoadingTemplate: false,
      result: null,
    };
  },
  methods: {
    downloadTemplate() {
      this.isLoadingTemplate = true;

      this.$http
        .get("support/inbound/template-inbound-notes", {
          responseType: "blob",
        })
        .then((res) => {
          this.isLoadingTemplate = false;
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "template_change_inbound_notes.xlsx");
          document.body.appendChild(link);
          link.click();
          link.remove();
          this.$vs.notify({
            color: "success",
            title: "Success",
            text: "Template berhasil didownload.",
          });
        })
        .catch((error) => {
          this.isLoadingTemplate = false;
          this.$emit("error", error);
        });
    },

    handleFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        const validTypes = [
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          "application/vnd.ms-excel",
        ];
        if (!validTypes.includes(file.type)) {
          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: "File harus berformat .xlsx atau .xls",
          });
          this.selectedFile = null;
          return;
        }
        this.selectedFile = file;
        this.result = null;
      }
    },

    submitUpdate() {
      if (!this.selectedFile) {
        this.$vs.notify({
          color: "danger",
          title: "Error",
          text: "Pilih file terlebih dahulu",
        });
        return;
      }

      this.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: "Konfirmasi",
        text: "Apakah kamu yakin ingin memperbarui inbound notes?",
        acceptText: "Ya, Process",
        accept: () => {
          this.isSubmitting = true;

          const formData = new FormData();
          formData.append("file", this.selectedFile);

          this.$http
            .post("support/inbound/update-inbound-notes", formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((res) => {
              this.isSubmitting = false;
              this.result = res.data.data;
              this.$vs.notify({
                color: "success",
                title: "Success",
                iconPack: "feather",
                icon: "icon-check",
                text: res.data.message || "Inbound notes berhasil diupdate.",
              });
              this.selectedFile = null;
              this.$refs.fileInput.value = "";
            })
            .catch((error) => {
              this.isSubmitting = false;
              this.$emit("error", error);
            });
        },
      });
    },
  },
};
</script>

<style>
.btn-download-success .vs-button-background,
.btn-download-success:hover .vs-button-background {
  background: #5cb85c !important;
}
.btn-download-success .vs-button-text,
.btn-download-success:hover .vs-button-text {
  color: #fff !important;
}
.btn-download-success i,
.btn-download-success:hover i {
  color: #fff !important;
}
</style>
